import React from 'react';

const BarbieBadge = (props) => (
  <img
    {...props}
    alt="Made with Barbie™"
    src="https://cdn.shopify.com/s/files/1/0051/6295/8946/files/Barbie_Badge_V2.png?v=1662486579"
  />
);

export default BarbieBadge;
